import './svg4everybody';

export default () =>
  typeof window.svg4everybody === 'function' && window.svg4everybody();
